﻿var validationClass = document.querySelectorAll(".field-validation-error");

for (x = 0; x < validationClass.length; x++) {
	validationClass[x].parentElement.parentElement.classList.add("input-validate-error")
}

